import React, { Fragment, useEffect, useState } from "react";
import general from "../../../general";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import $ from "jquery";
import { useScroll, useUpdate } from "ahooks";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import { splitStr } from "../../../utils/commonFunc";
import { useLogin } from "../../../lib/LoginContext";

// 新游预约
export default (props) => {
  const update = useUpdate();

  const { setShowLogin } = useLogin();

  const [init, setInit] = useState();
  const [loading, setLoading] = useState();
  const [page, setPage] = useState(1);
  const [gameGroups, setGameGroups] = useState({});
  const [more, setMore] = useState(true);
  const load = (parms = {}) => {
    if (loading) {
      return;
    }
    setLoading(true);
    Dialog.loading();
    let tmp = {
      pagination: { page: page },
    };
    if (parms.page) {
      tmp.pagination = { page: parms.page };
    }
    general.axios
      .post("/v3/reserveGames", tmp)
      .finally(() => {
        setLoading(false);
        Dialog.close();
      })
      .then(({ data: resData }) => {
        setInit(true);
        let result = resData.data;
        if (parms.page) {
          setPage(parms.page);
        }
        for (const game of result.game_list) {
          let gameDate = dayjs.unix(game.starting_time);
          let group = gameDate.format("MM/DD");

          const today = dayjs();
          const tomorrow = today.add(1, "day");
          const dayAfterTomorrow = today.add(2, "day");

          if (gameDate.isSame(tomorrow, "day")) {
            group += " 明天上线";
          } else if (gameDate.isSame(dayAfterTomorrow, "day")) {
            group += " 后天上线";
          }

          if (!gameGroups[group]) {
            gameGroups[group] = [];
            gameGroups[group].push(game);
          } else {
            let index = gameGroups[group].findIndex(
              (value) => value.game_id === game.game_id
            );
            if (index === -1) {
              gameGroups[group].push(game);
            }
          }
        }
        setGameGroups(gameGroups);
        setMore(result.paginated.more);
        console.log("6666666666", gameGroups);
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };
  useEffect(() => {
    if (props.active && !init) {
      load();
    }
  }, [props.active]);

  const scroll = useScroll();
  useEffect(() => {
    if (props.active && init) {
      if (scroll?.top < -80) {
        load({ page: 1 });
      }
      if (
        scroll?.top + window.innerHeight + 20 > $(document).height() &&
        more
      ) {
        load({ page: page + 1 });
      }
    }
  }, [scroll, props.active]);

  const reserveCallback = (game) => {
    if (!general.isLogin()) {
      setShowLogin(true);
      document.body.style.overflow = "hidden";
      return;
    }

    general.axios
      .post(game.is_reserved ? "/v3/cancelReserveGame" : "/v3/reserveGame", {
        id: game.maiyou_gameid,
      })
      .then((res) => {
        let result = res.data;
        if (!result.status.succeed) {
          Dialog.error(result.status.error_desc);
          return;
        }
        game.is_reserved = !game.is_reserved;
        update();
        Dialog.success(game.is_reserved ? "预约成功" : "取消预约");
      })
      .catch((err) => Dialog.error("reserveGame " + err.message));
  };

  return (
    <div>
      {gameGroups && Object.entries(gameGroups).length > 0 && (
        <>
          {Object.entries(gameGroups).map(([group, games]) => (
            <dl className="new-new" key={group}>
              <dt>{group}</dt>
              <dd>
                {games.map((game) => (
                  <Link
                    to={`/game?id=${game.game_id}`}
                    key={game.game_id}
                    className="new-new-item"
                  >
                    <div className="data">
                      <div className="icon">
                        <Image src={game.game_image?.thumb} />
                      </div>

                      <div className="info">
                        <div className="name">
                          <span>{game.game_name_main || game.game_name}</span>

                          {game?.game_tags?.is_special_server_game == 2 && (
                            <div className="dedicated-server">专服</div>
                          )}
                        </div>

                        <div className="game-labels">
                          {game?.game_tags?.is_free_version == 2 ? (
                            <div className="is-free-version">
                              <span>免费版</span>
                            </div>
                          ) : (
                            <>
                              {game.discount < 1 ? (
                                <div className="is-free-version">
                                  {parseFloat((game.discount * 10).toFixed(2))}
                                  折
                                </div>
                              ) : null}
                            </>
                          )}

                          <div className="game-classify">
                            {splitStr(game?.game_classify_type)}
                          </div>
                        </div>

                        <div className="subscribe-time">
                          {dayjs.unix(game.starting_time).format("MM.DD HH:mm")}
                          首发
                        </div>
                      </div>
                    </div>

                    <div
                      className={game.is_reserved ? "active opt" : "opt"}
                      onClick={(e) => {
                        e.preventDefault();
                        reserveCallback(game);
                      }}
                    >
                      {game.is_reserved ? "已预约" : "预约"}
                    </div>
                  </Link>
                ))}
              </dd>
            </dl>
          ))}
        </>
      )}

      {Object.entries(gameGroups).length > 0 && !more ? (
        <div className="view-end">别撩啦！已经到底啦~</div>
      ) : null}
    </div>
  );
};
